import { useState, useEffect } from "react";
import { API_BASE_URL } from "../config";

export const useNotifications = () => {
  const [unreadCount, setUnreadCount] = useState(0);
  const [notifications, setNotifications] = useState([]);

  const rawRole = localStorage.getItem("role");
  const role = rawRole === "admin" ? "admin" : "user";
  const apiBase = `${API_BASE_URL}/api/${role}`;

  const fetchUnreadCount = async () => {
    try {
      const res = await fetch(`${apiBase}/notifications/unread-count`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        credentials: "include",
      });
      if (res.ok) {
        const data = await res.json();
        setUnreadCount(typeof data.count === "number" ? data.count : 0);
      } else {
        setUnreadCount(0);
      }
    } catch (error) {
      console.error("❌ Failed to fetch notification count:", error);
      setUnreadCount(0);
    }
  };

  const fetchNotifications = async () => {
    try {
      const res = await fetch(`${apiBase}/notifications`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        credentials: "include",
      });
      if (res.ok) {
        const data = await res.json();
        setNotifications(Array.isArray(data) ? data : []);
      } else {
        setNotifications([]);
      }
    } catch (error) {
      console.error("❌ Failed to fetch notifications:", error);
      setNotifications([]);
    }
  };

  const markAllAsRead = async () => {
    try {
      await fetch(`${apiBase}/notifications/mark-read`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        credentials: "include",
      });
      fetchUnreadCount();
      fetchNotifications();
    } catch (err) {
      console.error("❌ Failed to mark notifications as read:", err);
    }
  };

  useEffect(() => {
    fetchUnreadCount();
    fetchNotifications();
  }, []);

  return {
    unreadCount,
    notifications,
    fetchUnreadCount,
    fetchNotifications,
    markAllAsRead,
  };
};
